import { PostType } from '~/constants';

export const isDraft = (type) => type === PostType.DRAFT;
